(() => {
  if (customElements.get('reviews-masonry-layout')) {
    return;
  }

  class ReviewsMasonryLayout extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.msnry = new Masonry(this, {
        itemSelector: '.js-tile',
        columnWidth: '.js-tile',
        percentPosition: true,
        horizontalOrder: true,
        gutter: 24,
        transitionDuration: 0,
      });

      document.addEventListener('shopify:section:select', () => {
        setTimeout(() => {
          this.refresh();
        }, '100');
      });
    }

    refresh() {
      this.msnry.layout();
    }
  }

  customElements.define('reviews-masonry-layout', ReviewsMasonryLayout);
})();
